module.exports = __webpack_public_path__ + "media/images/application/template/download-ed74c51b2a17d278d77c19e73dcfbcfb.svg";